export enum OutlookRange {
  ThisMonth = 'this-month',
  Today = 'today',
  Past30 = 'past-30',
  Next7 = 'next-7',
  Next30 = 'next-30',
  Custom = 'custom',
}

export interface OutlookImportSelection {
  eventIds: string[];
  seriesIds: string[];
}

export interface GraphDateTimeTimeZone {
  dateTime: string;
  timeZone: string;
}

export interface GraphEmailAddress {
  name?: string;
  address?: string;
}

export interface GraphAttendee {
  emailAddress?: GraphEmailAddress;
  type?: string;
}

export type GraphEventType = 'singleInstance' | 'occurrence' | 'exception' | 'seriesMaster';

export interface GraphCalendarEvent {
  id: string;
  iCalUId?: string;
  subject?: string;
  start?: GraphDateTimeTimeZone;
  end?: GraphDateTimeTimeZone;
  organizer?: { emailAddress?: GraphEmailAddress };
  attendees?: GraphAttendee[];
  isOnlineMeeting?: boolean;
  onlineMeeting?: { joinUrl?: string } | null;
  type?: GraphEventType;
  seriesMasterId?: string;
  isCancelled?: boolean;
}

export interface GraphCalendarViewResponse {
  value: GraphCalendarEvent[];
  '@odata.nextLink'?: string;
}

export interface OutlookMeeting {
  id: string;
  iCalUId?: string;
  seriesMasterId?: string;
  title: string;
  startIso: string;
  endIso: string;
  startMs: number;
  durationMinutes: number;
  organizerName: string;
  organizerEmail: string;
  attendeeCount: number;
  attendeeEmails: string[];
  isRecurring: boolean;
  isOnlineMeeting: boolean;
  joinUrl?: string;
  isCancelled: boolean;
}
